import { useParams } from 'react-router-dom'

const useRouteLoaderRouteId = (routeId: string): string => {
  const { strategyId } = useParams()
  return strategyId ? `strategy-${routeId}` : routeId
}

export default useRouteLoaderRouteId
